import React, { useEffect, useState } from "react";
import { Box, Divider, Grid, Typography, Button } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import CustomSelect from "../../../../../../Components/CustomSelect";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import FeedbackModal from "./FeedbackModal";
import MaterialTable from "material-table";
import { TooltipWrapper } from "../../../../../../Common/Utils/common_utils";

import {
  deleteFeedback,
  fetchFeedback,
  fetchFeedbackDropdownList,
} from "./store/FeedbackService";
import { useLocation } from "react-router";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Link } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
    marginBottom: "2rem",
  },
  inputLabel: {
    top: "50%",
    left: "10px",
    transform: "translate(0, -50%)",
  },
  feedbackButton: {
    textTransform: "none",
  },
  overviewContainer: {
    position: "sticky",
    top: 64,
    paddingTop: 40,
    background: "#fff",
    zIndex: 2,
  },
}));

const Feedback = (props) => {
  const { setPageUrl } = props;
  const [modal, setModal] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const feedbackData = useSelector((state) => state?.feedback);
  const [dropdownValue, setDropdownValue] = useState(undefined);
  const [currentSelection, setCurrentSelection] = useState(undefined);

  const sortByArray = [
    { id: 1, name: "all", value: "All" },
    { id: 2, name: "asc", value: "Ascending" },
    { id: 3, name: "desc", value: "Descending" },
  ];

  useEffect(() => {
    const orgId = props?.pageData?.organisation_id;
    dispatch(fetchFeedbackDropdownList(orgId));
  }, [dispatch]);

  useEffect(() => {
    const param = location?.state?.currentAssignment?.id;
    dispatch(
      fetchFeedback(
        param,
        dropdownValue?.session_scenario_id,
        dropdownValue?.sort_id,
        dropdownValue?.given_by_id
      )
    );
  }, [dispatch, dropdownValue]);

  const onCreate = () => {
    const param = location?.state?.currentAssignment?.id;
    dispatch(
      fetchFeedback(
        param,
        dropdownValue?.session_scenario_id,
        dropdownValue?.sort_id,
        dropdownValue?.given_by_id
      )
    );
    setCurrentSelection(undefined);
  };

  const handleDeleteFeedback = (id) => {
    dispatch(deleteFeedback(id, onCreate));
  };
  const columns = [
    {
      title: "Session scenario",
      field: "session_scenario",
      customSort: (a, b) => a.session_scenario.localeCompare(b.session_scenario),

    },
    // {
    //   title: "Session notes",
    //   sorting: false,
    //   // emptyValue: '-',
    //   // hidden: true,
    //   render: (rowData ) => (
    //     <div id={`div-${rowData?.session_notes}`}>
    //       {rowData?.session_notes.map((note) => (
    //   <Box>{note}</Box>
    // )) || "-"}
    //     </div>
    //   ),
    // },
    {
      title: "Given by",
      field: "given_to",
      sorting: false,
      render: (rowData ) => (
        <div>
{rowData?.employee_name
            ?.map((item) => item)
            .join(", ")}   
                </div>
  
      ),
    },
    {
      title: "Given to",
      field: "given_to",
      sorting: false,

    },
    {
      title: "Feedback",
      field: "feedback",
      sorting: false,

    },
  ];
  return (
    <>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid
          item
          xs={11}
          style={{ textAlign: "center" }}
          direction="row"
          justify="center"
          alignItems="center"
          className={classes.overviewContainer}
        >
          <AppBar position="static" className={classes.appBar} elevation={0}>
            <Toolbar>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                xs={12}
              >
                <Grid item xs={6}>
                  <Typography variant="h1" style={{ color: "#4A4A4A" }}>
                    <Box textAlign="left" fontWeight="fontWeightBold">
                      Feedback
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Box textAlign="right">
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => {
                        setModal(true);
                      }}
                      style={{ textTransform: "none" }}
                    >
                      Add feedback
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </Grid>
        <Grid item xs={11}>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={2}>
              <Typography variant="h2">
                <Box mb={1}>Given by</Box>
              </Typography>
              <FormControl style={{ width: "100%" }} variant="outlined">
                <Select
                  defaultValue={dropdownValue?.given_by_id || "all"}
                  labelId="given_by_id"
                  autoFocus
                  id="given_by_id"
                  name={"given_by_id"}
                  onChange={(event) => {
                    setDropdownValue({
                      ...dropdownValue,
                      [event.target.name]: event.target.value,
                    });
                  }}
                >
                  {feedbackData?.dropDownlist?.employees?.length && (
                    <MenuItem key="All" value="all">
                      <Typography variant="h2">All</Typography>
                    </MenuItem>
                  )}
                  {feedbackData?.dropDownlist?.employees?.length && (
                    <MenuItem key="Acuity admin" value="acuity_admin">
                      <Typography variant="h2">Acuity admin</Typography>
                    </MenuItem>
                  )}
                  {feedbackData?.dropDownlist?.employees?.map(
                    (data, index) => {
                      return (
                        <MenuItem key={index} value={data?.id}>
                          <Typography variant="h2">{data?.name}</Typography>
                        </MenuItem>
                      );
                    }
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="h2">
                <Box mb={1}>Session scenario</Box>
              </Typography>
              <FormControl style={{ width: "100%" }} variant="outlined">
                <Select
                  defaultValue={dropdownValue?.session_scenario_id || "all"}
                  labelId="session_scenario_id"
                  id="session_scenario_id"
                  name={"session_scenario_id"}
                  onChange={(event) => {
                    setDropdownValue({
                      ...dropdownValue,
                      [event.target.name]: event.target.value,
                    });
                  }}
                >
                  {feedbackData?.dropDownlist?.employees?.length && (
                    <MenuItem key="All" value="all">
                      <Typography variant="h2">All</Typography>
                    </MenuItem>
                  )}
                  {feedbackData?.dropDownlist?.session_scenario?.map(
                    (data, index) => {
                      return (
                        <MenuItem key={index} value={data?.id}>
                          <Typography variant="h2">{data?.value}</Typography>
                        </MenuItem>
                      );
                    }
                  )}
                </Select>
              </FormControl>
            </Grid>
           
            <Grid item xs={6} style={{ textAlign: "end" }}>
              <Typography variant="h2">
                <Link
                  href="javascript:void(0)"
                  color="secondary"
                  onClick={() => {
                    setPageUrl("Evaluation");
                  }}
                >
                  View Feedback from evaluation
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={11}>
          <Grid
            container
            direction="row"
            style={{
              marginTop: 20,
              textAlign: "left",
              borderWidth: 1,
              borderColor: "#ddd",
              borderStyle: "solid",
              padding: 16,
            }}
          >
            <Grid item xs={2}>
              <Typography variant="h2" style={{ color: "rgba(7,127,131,.75)" }}>
                <Box fontWeight="fontWeightBold">Session scenario</Box>
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="h2" style={{ color: "rgba(7,127,131,.75)" }}>
                <Box fontWeight="fontWeightBold">Session notes</Box>
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="h2" style={{ color: "rgba(7,127,131,.75)" }}>
                <Box fontWeight="fontWeightBold">Given by</Box>
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="h2" style={{ color: "rgba(7,127,131,.75)" }}>
                <Box fontWeight="fontWeightBold">Given to</Box>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h2" style={{ color: "rgba(7,127,131,.75)" }}>
                <Box fontWeight="fontWeightBold">Feedback</Box>
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="h2" style={{ color: "rgba(7,127,131,.75)" }}>
                <Box fontWeight="fontWeightBold">Action</Box>
              </Typography>
            </Grid>
          </Grid>
        </Grid> */}
        {/* <Grid item xs={11}>
          <Box>
            {feedbackData?.feedbackData?.length ? (
              feedbackData?.feedbackData?.map((option: any) => {
                return (
                  <>
                    <Grid
                      container
                      direction="row"
                      style={{
                        borderWidth: 1,
                        textAlign: "left",
                        borderColor: "#ddd",
                        borderStyle: "solid",
                        padding: 16,
                      }}
                    >
                      <Grid item xs={2} style={{ paddingInline: 5 }}>
                        <Typography variant="h2" style={{ color: "rgb(35, 35, 35)" }}>
                          <Box>{option?.session_scenario || "-"}</Box>
                        </Typography>
                      </Grid>
                      <Grid item xs={2} style={{ paddingInline: 5 }}>
                        <Typography variant="h2" style={{ color: "rgb(35, 35, 35)" }}>
                          <Box>
                            {option?.session_notes.map((note: any) => (
                              <Box>{note}</Box>
                            )) || "-"}
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid item xs={2} style={{ paddingInline: 5 }}>
                        <Typography variant="h2" >
                          <Box>
                            {option?.acuity_admin
                              ? "Acuity admin"
                              : option?.employee_name
                                  ?.map((item: any) => item)
                                  .join(", ")}
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid item xs={2} style={{ paddingInline: 5 }}>
                        <Typography variant="h2" style={{ color: "#320032" }}>
                          <Box>
                            {option?.given_to
                              ?.split(",")
                              .map((item: any) => item)
                              .join(", ") || "-"}
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid item xs={3} style={{ paddingInline: 5 }}>
                        <Typography variant="h2" style={{ color: "#320032" }}>
                          <Box>{option?.feedback || "-"}</Box>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        style={{ paddingInline: 5, display: "flex" }}
                      >
                        <EditIcon
                          style={{ cursor: "pointer", marginRight: "10px" }}
                          onClick={() => {
                            setCurrentSelection(option);
                            setModal(true);
                          }}
                        />
                        <DeleteIcon
                          onClick={() => handleDeleteFeedback(option.id)}
                          style={{ cursor: "pointer" }}
                        />
                      </Grid>
                    </Grid>
                    <Divider />
                  </>
                );
              })
            ) : (
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{
                  borderWidth: 1,
                  borderColor: "#ddd",
                  borderStyle: "solid",
                  padding: 16,
                }}
              >
                <Grid item xs={3}>
                  <Typography variant="h2" style={{ color: "#232323" }}>
                    <Box>{"Record not found"}</Box>
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Box>
        </Grid> */}
        <Grid item xs={11}>
          <MaterialTable
              title={"" }
             
              data={feedbackData.feedbackData}
              options={{
                searchFieldAlignment: "left",
                emptyRowsWhenPaging: false,
                addRowPosition: "first",
                pageSize: 20,
                actionsColumnIndex: -1,
                search:false
              }}
              columns={columns}
              actions={[
                {
                  icon: () => <EditIcon fontSize="small" />,
                  tooltip: <TooltipWrapper text="Edit" />,
                  onClick: (event, rowData) => {
                    setCurrentSelection(rowData);
                    // setAction('edit'); commentin temporay
                    setModal(true);
                  },
                },
                {
                  icon: () => <DeleteIcon fontSize="small" />,
                  tooltip: <TooltipWrapper text="Delete" />,
                  onClick: (event, rowData) => {
                    handleDeleteFeedback(rowData.id);
                  },
                },
              
             
              ]}
           
            />
            </Grid>
      </Grid>

      {modal ? (
        <FeedbackModal
          {...props}
          currentSelection={currentSelection}
          onCreate={onCreate}
          pageData={props?.pageData}
          isOpen={modal}
          onClose={() => {
            setModal(false);
            setCurrentSelection(undefined);
          }}
        />
      ) : null}
    </>
  );
};

export default Feedback;
